import { createSelector } from 'reselect';
import { rootSelector as settingsRootSelector } from '../selectors';

export const rootSelector = createSelector(
  settingsRootSelector,
  settings => settings.mobileRecording,
);

/**
 * Returns the current mobileRecordingSettings.
 */
export const settingsSelector = createSelector(rootSelector, ({ settings }) => settings);

/**
 * Returns the current the boolean value of whether the console watcher is enabled.
 */
export const consoleWatcherEnabledSelector = createSelector(
  settingsSelector,
  data => data?.consoleWatcherEnabled,
);
